import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ChargingStationService {
  apiUrl2 = `${environment.API_URL2}/chrgStation`;
  apiUrl3 = `${environment.API_URL3}`;
  apiUrl4 = `${environment.API_URL2}`;
  public chargerDetail: any;
  public tabIndex: any;
  public chargerDashboard: any;
  public dashboardIndex: any;
  constructor(private http: HttpClient) { }


  create(params) {
    return this.http.post(`${this.apiUrl2}/crt/`, params);
  }
  update(params) {
    return this.http.post(`${this.apiUrl2}/upd/`, params);
  }

  getChargingStations() {
    return this.http.get(`${this.apiUrl2}/gtChargingStations`);
  }

  getChargingStationById(id) {
    return this.http.get(`${this.apiUrl2}/getChargingStationById/${id}`);
  }

  getChargingStationByCpoId(cpo_id) {
    return this.http.get(`${this.apiUrl2}/gtChargingStationByCpoId/${cpo_id}`);
  }

  getChargingStationByClientId(client_id) {
    return this.http.get(`${this.apiUrl2}/getChargingStationByClientId/${client_id}`);
  }

  delete(id) {
    return this.http.delete(`${this.apiUrl2}/dlt/${id}`);
  }

  getLocationTypes() {
    return this.http.get(`${this.apiUrl4}/mst/gtLocationTypes`);
    // let data =[ {id : 1,name : 'Parking Garage'},
    //   {id : 2,name : 'Underground Garage'},
    //   {id : 3,name : 'Other'},
    // ]

    // return data;
  }
  getRegisterTypes() {
    return this.http.get(`${this.apiUrl4}/mst/gtChargerRegistrationTypes`);
    // let data =[ {id : 1,name : 'Community'},
    //   {id : 2,name : 'Public'},
    //   {id : 3,name : 'Captive'},
    // ]
    // return data;
  }
  getElectricityLines() {
    return this.http.get(`${this.apiUrl4}/mst/gtElectricitylineTypes`);
    // let data =[ {id : 1,name : 'LT'},
    //   {id : 2,name : 'HT'}
    // ]
    // return data;
  }
  startChargingStation(params) {
    return this.http.post(`${this.apiUrl3}/remoteTransaction`, params);
  }
  stopChargingStation(params) {
    return this.http.post(`${this.apiUrl3}/remoteTransaction`, params);
  }

  changeAvailability(params) {
    return this.http.post(`${this.apiUrl3}/change_availability`, params);
  }
  unlockConnector(params) {
    return this.http.post(`${this.apiUrl3}/unlockconnector`, params);
  }
  dataTransfer(params) {
    return this.http.post(`${this.apiUrl3}/dataTransfer`, params);
  }

  clearCache(params) {
    return this.http.post(`${this.apiUrl3}/clearcache`, params);
  }

  reset(params) {
    return this.http.post(`${this.apiUrl3}/reset`, params);
  }

  getLocalListVersion(params) {
    return this.http.post(`${this.apiUrl3}/getlocallistversion`, params);
  }

  getAvailabilityType() {
    return this.http.get(`${this.apiUrl4}/chargerMonitoring/getAvailabilityType`);
  }
  getChargingMenus() {
    return this.http.get(`${this.apiUrl4}/chargerMonitoring/getMenus`);
  }
  getdiagnostics(params) {
    return this.http.post(`${this.apiUrl3}/getdiagnostics`, params);
  }
  getUpdateFirmware(params) {
    return this.http.post(`${this.apiUrl3}/updatefirmware`, params);
  }
  getDataTriggerMessage(params) {
    return this.http.post(`${this.apiUrl3}/triggermessage`, params);
  }
  getChangeConfiguration(params) {
    return this.http.post(`${this.apiUrl3}/changeconfiguration`, params);
  }
  getReserveNow(params) {
    return this.http.post(`${this.apiUrl3}/reservenow`, params);
  }
  getHeartBeat(params) {
    return this.http.post(`${this.apiUrl3}/heartbeat`, params);
  }
  getActiveChargingStationsWithChargersAndConnectorsCW(login_id) {
    return this.http.get(`${this.apiUrl2}/getActiveChargingStationsWithChargersAndConnectorsCW/${login_id}`);
  }
  getActiveChargingStationsCW(login_id) {
    return this.http.get(`${this.apiUrl2}/gtActiveChargingStationsCW/${login_id}`);

   }

  // getAllChargingStationsWithChargersAndConnectorsCW(user_id){
  //   return this.http.get(`${this.apiUrl2}/getAllChargingStationsWithChargersAndConnectorsCW/${user_id}`);
  // }
  getConfiguration(params) {
    return this.http.post(`${this.apiUrl3}/getConfiguration`, params);
  }
  getStatus(params) {
    return this.http.post(`${this.apiUrl3}/status`, params);
  }
  getChargerConfigurationKeys() {
    return this.http.get(`${this.apiUrl4}/master/getChargerConfigurationKeys`);
  }
  getMultipleChargerSerial() {
    let data = [{ id: 1, serial_no: 'ktech_1' },
    { id: 2, serial_no: 'ktech_2' },
    { id: 3, serial_no: 'ktech_3' },
    ]
    return data;
  }
  getChargingStationsByUserRoleAndLatLong(user_id, params) {
    return this.http.post(`${this.apiUrl2}/getChargingStationsByUserRoleAndLatLong/${user_id}`, params);
  }
  getchargerConnectorStatus(charger_id) {
    return this.http.get(`${this.apiUrl3}/chargerConnectorStatus/${charger_id}`,);
  }
  getChargingStationsByUserRoleAndLatLongUW(user_id, params) {
    return this.http.post(`${this.apiUrl2}/getChargingStationsByUserRoleAndLatLongUW/${user_id}`, params);
  }
  // ----------------- new API with ccs--------------------------------------------------
  getAllChargingStationsWithChargersAndConnectorsCCS(login_id, client_id, cpo_id, station_id, params) {
    return this.http.get(`${this.apiUrl2}/gtActiveChargingStationsWithChargersAndConnectorsCCS/${login_id}/${client_id}/${cpo_id}/${station_id}`);
  }
}
